import api from "./api";

const certificateService = {
  get: (jwttoken) =>
    api.get(`/certificates`, {
      headers: { 'Authorization': `Bearer ${jwttoken}` }
    }),
};
export default certificateService;